module.exports = __webpack_public_path__ + "img/Group123.52532f6d.png";